// Routing paths
const Path = {
  HOME: "/",
  CONTACTUS: "/contactUs",
  ARCHITECTING: "/architectingNext",
  CERTIFICATES: "/certificates",
  // B2B: "/B2B",
};
export default Path;
